package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2024_03_15_Day_1
import com.veldekar.components.logs.Log_2024_03_15_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2024-03-15")
@Composable
public fun Log_2024_03_15(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Ambush on the Road",
        ogTitle = "Ambush on the Road",
        date = LocalDate(2_024, 3, 15),
        ogDescription = "The Carnage Crew and Dolly Mott ambush the heroes on the road to Zedj, leading to a fierce nighttime battle.",
        ogImage = "ai/2024-03-15.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-46", dateString = "Newgrowth 46")
        Log_2024_03_15_Day_1()
        SessionDayHeader(dayId = "newgrowth-47", dateString = "Newgrowth 47")
        Log_2024_03_15_Day_2()
    }
}
